import React from 'react'
import styled from '@emotion/styled'

import vw from 'styles/utils';
import media from 'styles/media';

function Copyright() {
  return (
    <Root>
      <Logo src={require('assets/images/footer/logo-itri.png')} alt="logo-itri" />
      <ContentWrapper>
        <Contact>
          <span>
            版權所有 © 工業技術研究院 產業科技國際策略發展所
          </span>
          <Address href="https://goo.gl/maps/gTymcf8MZso7aYdy8" target='_blank' rel="noopener">
            <i className="fa fa-map-marker g-mr-10" />
            310 臺灣新竹縣竹東鎮中興路四段195號10館
          </Address>
          <Phone href="tel:+886-3-5912340">
            <i className="fa fa-phone g-mr-5" />
            +886-3-5912340
          </Phone>
        </Contact>
        <OtherInfoWrapper>
          <ContactUs href="https://ieknet.iek.org.tw/contact/Default.aspx" target='_blank' rel="noopener">
            <i className="fa fa-envelope g-font-size-28" />
            ContactUs
          </ContactUs>
          <SiteMap href="https://ieknet.iek.org.tw/sitemap/Default.aspx" target='_blank' rel="noopener">
            <i className="fa fa-sitemap g-font-size-28 g-font-size-20--xs" />
            SiteMap
          </SiteMap>
        </OtherInfoWrapper>
      </ContentWrapper>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background: rgba(0, 0, 0, 0.5);
  padding: 20px 0;
  position: relative;

  @media ${media.tablet} {
    
  }

  @media ${media.desktop} {
    flex-direction: row;
    align-items: center;
  }

  ${vw('padding-left', 15, 30, 200)}
  ${vw('padding-right', 15, 30, 200)}
`;

const Logo = styled.img`
  ${vw('width', 170)};
  ${vw('height', 40)};
  ${vw('margin-bottom', 10, 10, 0)}
`;

const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  @media ${media.tablet} {
    flex-direction: row;
    align-items: center;
  }
`;

const Contact = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.75);

  ${vw('font-size', 10, 17)};
  ${vw('line-height', 15, 25)};
  ${vw('margin-left', 0, 0, 50)};
`;

const Address = styled.a`
  font-weight: 300;
  color: rgba(255, 255, 255, 0.75);

  ${vw('font-size', 10, 17)};
  ${vw('line-height', 15, 25)};

  > i {
    ${vw('margin-right', 8)};
  }
`;

const Phone = styled.a`
  font-weight: 300;
  color: rgba(255, 255, 255, 0.75);

  ${vw('font-size', 10, 17)};
  ${vw('line-height', 15, 25)};
  ${vw('margin-bottom', 10, 0)};

  > i {
    ${vw('margin-right', 8)};
  }
`;

const OtherInfoWrapper = styled.div`
  display: flex;
`;

const ContactUs = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  background-color: #585f69;

  ${vw('font-size', 10, 20)};
  ${vw('line-height', 15, 20)};
  ${vw('padding-top', 5)};
  ${vw('padding-bottom', 5)};
  ${vw('padding-left', 4, 2, 3)};
  ${vw('padding-right', 4, 2, 3)};
  ${vw('margin-right', 3, 4)};

  > i {
    ${vw('font-size', 20, 40)};
    ${vw('line-height', 20, 40)};
  }
`;

const SiteMap = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  background-color: #585f69;

  ${vw('font-size', 10, 20)};
  ${vw('line-height', 15, 20)};
  ${vw('padding-top', 5)};
  ${vw('padding-bottom', 5)};
  ${vw('padding-left', 7)};
  ${vw('padding-right', 7)};

  > i {
    ${vw('font-size', 20, 40)};
    ${vw('line-height', 20, 40)};
  }
`;

export default Copyright
